var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternal = function SvgExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 3.1a.4.4 0 0 0 0 .8h3.034l-7.317 7.317a.4.4 0 0 0 .565.566L16.1 4.466V7.5a.4.4 0 0 0 .8 0v-4a.4.4 0 0 0-.4-.4zm-8 2.8a.6.6 0 0 0-.6.6v9a.6.6 0 0 0 .6.6h9a.6.6 0 0 0 .6-.6V11a.4.4 0 0 1 .8 0v4.5a1.4 1.4 0 0 1-1.4 1.4h-9a1.4 1.4 0 0 1-1.4-1.4v-9a1.4 1.4 0 0 1 1.4-1.4H9a.4.4 0 1 1 0 .8z",
    clipRule: "evenodd"
  })));
};
export default SvgExternal;